import { useState } from 'react'
import { Button } from '@/components/ui/button'

export function CancelBookingModal({ booking, onClose, onConfirm, isPending }: {
  booking: { courseName: string; clientName: string }
  onClose: () => void
  onConfirm: (notifyClient: boolean) => void
  isPending: boolean
}) {
  const [notifyClient, setNotifyClient] = useState(true)

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6">
        <h2 className="text-base font-semibold text-gray-900">Cancel booking</h2>
        <p className="text-sm text-gray-500 mt-1.5">
          Cancel the booking for <span className="font-medium text-gray-700">{booking.courseName}</span> ({booking.clientName})?
        </p>
        <label className="flex items-center gap-2 mt-4 text-sm text-gray-700 cursor-pointer">
          <input
            type="checkbox"
            checked={notifyClient}
            onChange={e => setNotifyClient(e.target.checked)}
            className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
          />
          Notify the client contact by email
        </label>
        <div className="flex items-center justify-end gap-2 mt-6">
          <Button variant="ghost" onClick={onClose} disabled={isPending}>Back</Button>
          <Button variant="destructive" onClick={() => onConfirm(notifyClient)} disabled={isPending}>
            {isPending ? 'Cancelling…' : 'Cancel booking'}
          </Button>
        </div>
      </div>
    </div>
  )
}
